<template>
  <div class="has-tooltip">
    <span
      class="tooltip rounded shadow-lg p-1 bg-white border border-teal -mt-8"
      >{{ message }}</span
    >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    message: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.tooltip {
  @apply invisible absolute;
}

.has-tooltip:hover .tooltip {
  @apply visible z-50;
}
</style>
